import { User } from '@/types/user.type'

export type Program = {
  id: string

  /** ID เจ้าของ program */
  ownerId: string

  /** ชื่อของ program */
  title: string

  /** รายละเอียดของ program */
  description: string

  /** URL รูปภาพปกของ program */
  thumbnailUrl: string

  /** แท็กสำหรับการค้นหาและจัดหมวดหมู่ */
  tags: string[]

  /** สถานะการเปิดใช้งาน */
  isEnabled: boolean

  recordStatus: ProgramRecordStatus

  /** สถานะของ program */
  status: ProgramStatus

  /** ประเภทของ program */
  type: ProgramType

  /** วันที่เผยแพร่ */
  publishedAt?: Date

  /** เปิดให้แชร์สาธารณะ */
  isPublic: boolean

  /** เปิดให้คอมเม้นต์ */
  isCommentActive: boolean

  /** วันที่สร้าง program */
  createdAt: Date

  /** วันที่อัปเดต program ล่าสุด */
  updatedAt: Date

  owner: User

  //TODO: สร้างก็ต่อเมื่อกดขอ stream key ที่ BO (อย่าลืม filter ออกตอนส่งให้ USER)
  streamKey?: string
  streamServerUrl?: string
  // audiences: Record<string, string>; // { "userId": "token" }
  streamKeyExpiresAt?: string

  channelName?: string

  files?: RecordFile[]
}

export interface ProgramFilters {
  page: number
  limit: number
  search: string
  isEnabled: string
  publishedAt: string
  type: ProgramType
  orderBy: string
}

export interface PaginationMeta {
  limit: number
  page: number
  total: number
}

export interface Pagination<T> extends PaginationMeta {
  items: T[]
}

export enum ProgramStatus {
  PENDING = 'pending',
  LIVE = 'live',
}

export interface RecordFile {
  name: string
  url: string
  displayName: string
  timeCreated: string
  isEnable?: boolean
}

export interface ProgramRecord {
  /** รหัสของ program record */
  id: string

  /** รหัสของ program */
  programId: string

  /** ชื่อที่แสดงของ record */
  displayName: string

  /** ชื่อไฟล์ */
  name: string

  /** URL ของไฟล์ video */
  fileUrl: string

  /** สถานะการลบ (soft delete) */
  isDeleted: boolean

  isEnabled: boolean

  /** วันที่ลบข้อมูล */
  deletedAt?: Date

  /** วันที่สร้างข้อมูล */
  createdAt: Date

  /** วันที่อัปเดตข้อมูลล่าสุด */
  updatedAt: Date
}

export enum ProgramRecordStatus {
  RECORDING = 'recording',
  STOPPED = 'stopped',
}

export enum ProgramType {
  ADMIN = 'admin',
  USER = 'user',
}
